var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmpty(_ref, svgRef) {
  var _ref2, _ref3, _ref4, _ref5;

  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 108,
    viewBox: "0 0 115 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.4861 71.6636C40.3774 72.3334 40.3212 73.018 40.3212 73.7139C40.3212 81.7384 47.7912 88.2436 57.0059 88.2436C66.2205 88.2436 73.6905 81.7384 73.6905 73.7139C73.6905 73.018 73.6343 72.3334 73.5257 71.6636H114.012V103.984C114.012 105.99 112.144 107.616 109.841 107.616H4.17116C1.86749 107.616 0 105.99 0 103.984V71.6636H40.4861Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.0809 71.2938C75.0809 79.987 66.9884 87.0343 57.0059 87.0343C47.0233 87.0343 38.9308 79.987 38.9308 71.2938C38.9308 71.0121 38.9393 70.7322 38.9561 70.4542H0L13.2927 36.2274C13.8658 34.7519 15.4553 33.7588 17.244 33.7588H96.7677C98.5564 33.7588 100.146 34.7519 100.719 36.2274L114.012 70.4542H75.0556C75.0724 70.7322 75.0809 71.0121 75.0809 71.2938Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.4372 72.4488C72.4372 79.1663 65.529 85.8227 57.0073 85.8227C48.4856 85.8227 41.5774 79.1663 41.5774 72.4488C41.5774 72.2311 41.5846 70.804 41.5989 70.5892H12.5149L23.8623 46.5629C24.3515 45.4227 25.7085 44.6553 27.2354 44.6553H86.7792C88.3061 44.6553 89.663 45.4227 90.1522 46.5629L101.5 70.5892H72.4156C72.4299 70.804 72.4372 72.2311 72.4372 72.4488Z",
    fill: "#EFF7F0",
    style: (_ref2 = {
      fill: "#EFF7F0"
    }, _defineProperty(_ref2, "fill", "color(display-p3 0.9373 0.9686 0.9412)"), _defineProperty(_ref2, "fillOpacity", 1), _ref2)
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.73804 70.7029V102.774C1.73804 103.945 2.82741 104.893 4.17121 104.893H109.841C111.184 104.893 112.274 103.945 112.274 102.774V70.7029L99.0727 36.712C98.7384 35.8513 97.8112 35.272 96.7678 35.272H17.2441C16.2007 35.272 15.2734 35.8513 14.9391 36.712L1.73804 70.7029Z",
    stroke: "#3AB67D",
    style: (_ref3 = {
      stroke: "#3AB67D"
    }, _defineProperty(_ref3, "stroke", "color(display-p3 0.2275 0.7137 0.4902)"), _defineProperty(_ref3, "strokeOpacity", 1), _ref3),
    strokeWidth: 2.13102
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.467 70.0825C24.9403 70.0825 30.8471 70.0825 37.1873 70.0825C39.7961 70.0825 39.7961 71.6791 39.7961 72.5041C39.7961 80.5286 47.4379 87.0338 56.8646 87.0338C66.2913 87.0338 73.9331 80.5286 73.9331 72.5041C73.9331 71.6791 73.9331 70.0825 76.5419 70.0825H111.233M9.1416 70.0825H12.5151H9.1416Z",
    stroke: "#3AB67D",
    style: (_ref4 = {
      stroke: "#3AB67D"
    }, _defineProperty(_ref4, "stroke", "color(display-p3 0.2275 0.7137 0.4902)"), _defineProperty(_ref4, "strokeOpacity", 1), _ref4),
    strokeWidth: 2.13102,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.9057 6.27521L76.4729 21.3535M55.7556 1.06543V21.3535V1.06543ZM19.467 6.27521L34.8998 21.3535L19.467 6.27521Z",
    stroke: "#7ECEA7",
    style: (_ref5 = {
      stroke: "#7ECEA7"
    }, _defineProperty(_ref5, "stroke", "color(display-p3 0.4941 0.8078 0.6549)"), _defineProperty(_ref5, "strokeOpacity", 1), _ref5),
    strokeWidth: 2.13102,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/Empty.a1532b78.svg";
export { ForwardRef as ReactComponent };